<template>
  <!-- for inviting/removing users in your practice -->
  <div>
    <!-- Add users -->
    <div class="columns mb-2">
      <div class="column has-text-left pl-5">
        <p class="title is-3">Users</p>
        <p class="subtitle is-5">Manage your practice.</p>
      </div>
      <div class="column is-3 is-flex is-align-items-flex-end">
        <div class="smallWidth is-flex is-justify-content-flex-end">
          <b-button
            @click="showAddEmployee = !showAddEmployee;"
            :loading="isLoading"
            class="is-info addButton mt-1 mb-0"
            rounded
          >
            <strong>Add User</strong>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="ready" class="is-flex is-flex-direction-column is-align-items-center">
      <div v-if="user.role==='OWNER'" class="smallWidth">
        <div v-if="showAddEmployee" class="is-flex is-flex-direction-column mb-2 addUser width-100">
          <div class="columns mb-0">
            <div class="column is-9">
              <b-field>
                <b-input
                  placeholder="First Name"
                  v-model="employee.name.first"
                  type="given-name"
                  icon="card-account-details"
                />
              </b-field>
              <b-field>
                <b-input
                  placeholder="Last Name"
                  v-model="employee.name.last"
                  type="family-name"
                  icon="card-account-details-outline"
                />
              </b-field>
              <b-field>
                <b-input placeholder="Email" v-model="employee.email" type="email" icon="email" />
              </b-field>
              <b-field>
                <b-input placeholder="Title" v-model="employee.title" icon="account" />
              </b-field>
            </div>
            <div class="is-flex is-justify-content-flex-end column">
              <b-button class="is-danger is-light" icon-right="close-thick" @click="showAddEmployee = false;" />
            </div>
          </div>
          <div class="is-flex is-justify-content-flex-start">
            <b-button :disabled="!canInvite" @click="save()" icon-right="account-plus" class="is-success">
              <strong>Save</strong>
            </b-button>
          </div>
        </div>

        <!-- Users list -->
        <div>
          <div
            v-for="user in users" :key="user.id"
            class="userRow is-flex is-align-items-center is-justify-content-space-between px-4 mb-2"
          >
            <div class="is-flex is-flex-direction-column is-align-items-center is-justify-content-center">
              <b-skeleton v-if="!user.profile_pic" circle width="4em" height="4em" />
              <img v-else :key="urlKey" :src="$root.getURL(user.profile_pic)" class="avatar">
            </div>
            <div class="column is-6 is-flex is-flex-direction-column is-align-items-flex-start">
              <p class="title is-5 is-clickable" @click="editUser(user)">
                {{ user.name.first }} {{ user.name.last }}
                <span v-if="user.status!=='Joined'" style="font-weight: 300;" class="subtitle is-6 mb-0">{{ user.status }}</span>
                <b-icon v-else icon="pencil" type="is-info" />
              </p>
              <p class="subtitle is-6 mb-0">
                {{ prettyRole(user.role) }}
                <span v-if="user.title" >
                  | {{ user.title }}
                </span>
              </p>
            </div>
            <div class="column is-4 is-flex is-flex-direction-column mt-4">
              <fileUpload
                v-if="user.status==='Joined'"
                :forUser="user.uid"
                uploadType="PROFILE_PICTURES"
                labelText="Drag & drop or <span style='text-decoration: underline; cursor: pointer!important;'>browse</span> profile image" 
                fileTypes="image/jpeg, image/png, image/webp"
              />

            </div>
            <div class="column is-1 is-flex is-align-items-center">
              <!-- <b-button
                @click="deleteTest(user)"
              >
                Delete Test
              </b-button> -->
              <b-button
                :disabled="user.role==='OWNER' || user.status!=='Joined'"
                @click="showDelete(user)"
                icon-right="delete"
                class="is-danger"
              />
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Edit user -->
    <b-modal v-model="showEditUser" :width="400">
      <div class="card">
        <div v-if="selectedUser" class="card-content">
          <b-field>
            <b-input
              placeholder="First Name"
              v-model="editUserData.name.first"
              type="given-name"
              icon="card-account-details"
            />
          </b-field>
          <b-field>
            <b-input
              placeholder="Last Name"
              v-model="editUserData.name.last"
              type="family-name"
              icon="card-account-details-outline"
            />
          </b-field>
          <b-field>
            <b-input disabled :placeholder="selectedUser.email" type="email" icon="email" />
          </b-field>
          <b-field>
            <b-input placeholder="Title" v-model="editUserData.title" icon="account" />
          </b-field>
          <div class="is-flex is-justify-content-flex-start">
            <b-button @click="confirmEditUser()" class="is-info" icon-right="send" rounded>
              <strong>Save Changes</strong>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>


  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

// import { references, db } from '@/main';

import fileUpload from "@/components/fileUpload/upload.vue";

import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: "addEmployees",
  components: {
    fileUpload
  },
  props: {
    title: {
      type: String,
      default: "Users"
    },
    subtitle: {
      type: String,
      default: "Manage your practice."
    }
  },
  data() {
    return {
      showAddEmployee: false,
      employee: {
        email: "",
        name: {
          first: "",
          last: ""
        },
        title: '',
        role: "PT",
        status: "Invited",
        profile_pic: 'https://storage.googleapis.com/aceso-webflow-project.appspot.com/practices/DEFAULTS/profile_pic.JPG'
      },
      urlKey: 0,
      showEditUser: false,
      selectedUser: null,
      editUserData: {
        name: {
          first: "",
          last: ""
        },
        title: "",
        email: ""
      }
    };
  },
  mounted() {
    this.$root.$on('uploaded_profile_pic', this.update);
  },
  computed: {
    canInvite() {
      const { email, name } = this.employee;
      if (email.length > 0 && name.first.length > 0 && name.last.length > 0) {
        return true
      } else return false
    },
    ...mapGetters({
      users: 'auth/getUsers'
    }),
    ...mapState({
      user: state => state.auth.user,
      practice: state => state.auth.practice,
      isLoading: state => state.auth.isLoadingSmall,
      ready: state => state.auth.isReady,
    }),
  },
  methods: {
    update() { // force update the image after upload
      this.urlKey++
    },
    prettyRole(role) {
      switch (role) {
        case "OWNER":
          return "Admin";
        default:
          return "User";
      }
    },
    async save() {
      await this.inviteUser(this.employee);
      await this.fetchPractice({ user: this.user }); // update firebase urls to beat browser caching
      this.employee = {
        email: "",
        name: {
          first: "",
          last: ""
        }
      };
    },
    async deleteTest({ email, uid, name }) {
      const host = 'http://localhost:5001/aceso-webflow-project/us-central1/fireExpress/api/deleteUser';
      axios.post(host, { email, uid, name }, { headers: { Authorization: `Bearer ${ await firebase.auth().currentUser.getIdToken(false) }` } })
    },

    showDelete({ email, uid, name }) {
      this.$buefy.dialog.confirm({
        title: 'Deleting account',
        message: `Are you sure you want to delete <b>${name.first} ${name.last}</b>? This action cannot be undone.`,
        confirmText: 'Delete Account',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteUser({ email, uid })
      })
    },

    editUser(user) {
      this.selectedUser = user;
      this.editUserData = user;
      this.showEditUser = true;
    },
    confirmEditUser() {
      try {
        this.storeEditUser(this.editUserData)
        this.showEditUser = false;
        this.selectedUser = null;
      } catch(err) {
        console.log(err);
      }
    },
    ...mapActions({
      inviteUser: "auth/inviteUser",
      fetchPractice: "auth/fetchPractice",
      deleteUser: "auth/deleteUser",
      storeEditUser: "auth/editUser"
    })
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  border-radius: 100%;
  width: 4em;
  height: 4em;
}

.smallWidth {
  width: 100% !important;
}

.addUser {
  background-color: white;
  border-radius: 8px;
  padding: 1em 1.5em;
}
.userRow {
  background-color: white;
  border-radius: 8px;
  // margin-bottom: 0.5em;
  min-height: 130px;
  max-height: 130px;
}

.addButton {
  background-color: #18a0fb;
  color: #ffffff;
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 18px;
  border-radius: 100px;
}

</style>